



import { popPostLoginRedirect, setTokens } from '@/helpers/authHelper'
import gql from 'graphql-tag'
import Vue from 'vue'
export default Vue.extend({
  name: 'Callback',
  mounted () {
    if (!this.$route.query?.code) {
      // No auth code to handle, return to login
      this.$router.push({ name: 'Login' })
      return
    }
    this.$apollo.mutate({
      mutation: gql`
        mutation codeToToken($code: String!, $redirectURI: String!){
          oauthToken(authCode: $code, redirectURI: $redirectURI) {
            token
            refreshToken
          }
        }
      `,
      variables: {
        code: this.$route.query?.code,
        redirectURI: process.env.VUE_APP_IDP_REDIRECT_URI || '',
      }
    }).then((resp) => {
      setTokens(resp.data.oauthToken.token, resp.data.oauthToken.refreshToken)
      this.$store.dispatch('updateFromTokens')
      const path = popPostLoginRedirect()
      if (path) {
        this.$router.push({ path })
      } else {
        this.$router.push({ name: 'Login' })
      }
    }).catch((err) => {
      const isAuthCodeInvalid = err.graphQLErrors?.some((gqlErr) => {
        const errMessage = (gqlErr.extensions?.response?.body?.error_description as string)?.toLowerCase()
        return errMessage === 'invalid authorization code'
      })
      if (isAuthCodeInvalid) {
        console.log('Auth code is invalid, redirecting to login')
        this.$router.push({ name: 'Login' })
      } else {
        console.error('Error while exchanging auth code for tokens: ', err)
        console.log('Logging out of idp and redirecting to login')
        this.$router.push({ name: 'Logout' })
      }
    })
  }
})
